import { useFormikContext } from 'formik';
import { get } from 'lodash';
import React, { memo } from 'react';
import { MODE_FIELD, Mode } from '../../../components/KendoDataGrid/constants';
import OverflowContent from '../../../components/OverflowContent';
import { FormikField, TextField } from '../../../components/forms/fields-next';
import { EMPTY_VALUE_PLACEHOLDER } from '../constants';
import { CustomSiteTemplateProps, EditableSite } from '../types';

const Editor: React.FC<CustomSiteTemplateProps> = memo(({ field }) => {
  const { getFieldProps, values } = useFormikContext<EditableSite>();

  return (
    <FormikField
      name={field}
    >
      <TextField
        {...getFieldProps(field)}
        defaultValue={undefined}
        size="small"
        readOnly={field !== 'siteName' && values?.isSameAsHQ}
      />
    </FormikField>
  );
});

export const TextFieldCellTemplate: React.FC<CustomSiteTemplateProps> = (props) => {
  const { field, dataItem, onClick } = props;
  const isEditMode = [Mode.add, Mode.edit].includes(dataItem[MODE_FIELD]);

  if (isEditMode) {
    return <Editor {...props} />;
  }

  const handleClick = () => onClick?.({ dataItem });
  const displayValue = get(dataItem, field, EMPTY_VALUE_PLACEHOLDER);

  return (
    <OverflowContent onClick={handleClick}>
      {displayValue}
    </OverflowContent>
  );
};
